
export const formatPhoneNumber = (phone: string | undefined): string => {
  if (!phone) return '';
  
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Format based on length and patterns
  if (cleaned.length === 10) {
    // Greek mobile format: 69X XXX XXXX or US format: (555) 123-4567
    if (cleaned.startsWith('69') || cleaned.startsWith('68')) {
      // Greek mobile
      return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6)}`;
    } else {
      // US format
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
  } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
    // US format with country code: +1 (555) 123-4567
    return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  } else if (cleaned.length === 12 && cleaned.startsWith('30')) {
    // Greek format with country code: +30 69X XXX XXXX
    return `+30 ${cleaned.slice(2, 5)} ${cleaned.slice(5, 8)} ${cleaned.slice(8)}`;
  } else if (cleaned.length >= 7) {
    // Generic format for other lengths
    return phone;
  }
  
  return phone;
};
